import { RequiredLabel } from '@/components/required-label';
import { Tabs } from '@/components/ui/tabs';

import { FileUploadSection } from './file-upload-section';

import { selectDocumentType } from '@/store/document-upload.selectors';
import { useDocumentUploadStore } from '@/store/document-upload.store';

export type DocumentType = 'file' | 'url' | 'text';

type DocumentUploadTabsProps = {
  onFileSelect: (files: File[]) => void;
};

export function DocumentUploadTabs({ onFileSelect }: DocumentUploadTabsProps) {
  const documentType = useDocumentUploadStore(selectDocumentType);
  const setDocumentType = useDocumentUploadStore(state => state.setDocumentType);

  return (
    <Tabs
      value={documentType}
      onValueChange={value => setDocumentType(value as DocumentType)}
      className="w-full"
    >
      {/* <DocumentTabsList /> */}
      <RequiredLabel className="text-sm font-medium text-foreground">Upload File</RequiredLabel>
      <FileUploadSection onFileSelect={onFileSelect} />
    </Tabs>
  );
}
